import { useEffect, createContext, useState } from 'react'
import { getAuth, getConfig } from '../lib/allauth'

export const AuthContext = createContext(null)

function Loading () {
  return <div>Starting...</div>
}

function LoadingError () {
  return <div>Loading error!</div>
}

export function AuthContextProvider (props) {
  const [auth, setAuth] = useState(undefined)
  const [config, setConfig] = useState(undefined)
  const [authError, setAuthError] = useState(null)

  useEffect(() => {
    function onAuthChanged (e) {
      setAuth(prevAuth => {
        if (typeof prevAuth === 'undefined') {
          console.log('Authentication status loaded')
        } else {
          console.log('Authentication status updated')
        }
        return e.detail
      })
    }

    document.addEventListener('allauth.auth.change', onAuthChanged)

    getConfig()
      .then(data => setConfig(data))
      .catch((e) => {
        console.error('getConfig failed:', e)
        setConfig({ status: 0, error: String(e) })
      })
    getAuth()
      .then(data => {
        if (data?.status === 401) {
          setAuth({ status: 401, meta: { is_authenticated: false } })
          setAuthError(null)
          return
        }

        if (data?.status === 200) {
          setAuth(data)
          setAuthError(null)
          return
        }

        console.error('Unexpected auth response:', data)
        setAuth(data)
        setAuthError(data)
      })
      .catch((e) => {
        console.error('getAuth failed:', e)
        setAuth({ status: 0, error: String(e) })
        setAuthError(e)
      })

    return () => {
      document.removeEventListener('allauth.auth.change', onAuthChanged)
    }
  }, [])

  const loading = (typeof auth === 'undefined') || (typeof config === 'undefined')

  const hasError =
    (config && config.status !== 200) ||
    (authError && auth?.status !== 401)

  return (
    <AuthContext.Provider value={{ auth, config }}>
      {loading
        ? <Loading />
        : (hasError
            ? <LoadingError />
            : props.children)}
    </AuthContext.Provider>
  )
}